/**
 * Created by jv on 31/03/2017.
 */
const utils = require("Sources/utils/utils");

var adminShared = {};

(function(AdminShared)
{
  AdminShared.setNavigationHighlight = function(link)
  {
    var navbar = $("#navbar .nav.navbar-nav");

    navbar.find("> li").removeClass("active");

    switch(link)
    {
      case "users":
        navbar.find("a[href='/admin/users']").parent().addClass("active");
        break;
      case "orders":
        navbar.find("a[href='/admin/orders-overview']").parent().addClass("active");
        break;
      case "subscriptions":
        navbar.find("a[href='/admin/subscriptions-overview']").parent().addClass("active");
        break;
      case "customers":
        navbar.find("a[href='/admin/customers-overview']").parent().addClass("active");
        break;
      case "mailing":
        navbar.find("a[href='/admin/mailing']").parent().addClass("active");
        break;
      case "stats":
        navbar.find("a[href='/admin/stats']").parent().addClass("active");
        break;
      default:
        break;
    }
  };

  (function setUpAdminLogo()
  {
    var $html = $("html");
    var $body = $("body");

    if(!$html.hasClass("admin"))
    {
      $("html").addClass("admin");
    }

    var icons = ["paper", "scissors", "rock"];

    $body.append("<span class='admin-indicator " + icons[Math.floor(Math.random()*icons.length)] + "'></span>");

    $(window).scroll(function(e)
    {
      setIndicatorTop();
    });

    function setIndicatorTop()
    {
      var scrollTop = $(document).scrollTop();
      var indicatorEl = $("body > .admin-indicator");

      if(scrollTop < 172)
      {
        var tmp = Math.max(172 - scrollTop + 5, 65);
        indicatorEl.css("top", tmp + "px");
      }
      else if(indicatorEl.scrollTop() !== 65)
      {
        indicatorEl.css("top", "65px");
      }
    }

    setIndicatorTop();
  }());
}(adminShared));

module.exports = adminShared;



// WEBPACK FOOTER //
// ./app/js/admin-shared.js